export default __webpack_public_path__ + "static/media/banner.138e7bce.png";